 
<script>
export default {
  name: 'phone-button',
  props: {
    btnProps: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    defaultBtnProps: {
      block: false,
      color: 'primary',
      href: 'tel:+16315819200'
    }
  })
}
</script>
<template>
<v-btn v-bind="{...defaultBtnProps, ...btnProps}"> <v-icon left>mdi-phone</v-icon> (631) 581-9200 </v-btn>
</template>

<style scoped>

</style>